import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';

import { selectMobilePlanData } from '@selectors/mobilePlan';

import { numberToSup } from '@utils/formatNumber';

import PriceText from '@common/components/PriceText';

import {
  CostsInfoWrapper,
  Heading,
  Price,
  AdditionalInfo,
  CostsItemInfoWrapper,
  PriceAdditionalInfo,
} from './CostsInfo.styled';

const SECTION_COST_INFO_PREFIX = 'mobile.orderForm.costInfo';

const CostsInfo = () => {
  const { t } = useTranslation();
  const { price: planMonthlyCost, setupFee: planOneTimePayment } =
    useSelector(selectMobilePlanData);

  return (
    <CostsInfoWrapper>
      <CostsItemInfoWrapper>
        <Heading>
          {t(`${SECTION_COST_INFO_PREFIX}.price`, 'Monatliche Kosten')}
        </Heading>
        <Price>
          {t(`${SECTION_COST_INFO_PREFIX}.currencySymbol`, 'CHF')}{' '}
          <PriceText>
            {planMonthlyCost && numberToSup(planMonthlyCost)}
          </PriceText>
        </Price>
        <PriceAdditionalInfo>
          {t('mobile.priceAdditionalInfo', 'Lebenslang gleicher Preis')}
        </PriceAdditionalInfo>
      </CostsItemInfoWrapper>
      <CostsItemInfoWrapper>
        <AdditionalInfo>
          {t(`${SECTION_COST_INFO_PREFIX}.setupFee`, 'Aktivierung & SIM-Karte')}{' '}
          {t(`${SECTION_COST_INFO_PREFIX}.currencySymbol`, 'CHF')}{' '}
          <PriceText>
            {planOneTimePayment && numberToSup(planOneTimePayment)}
          </PriceText>
        </AdditionalInfo>
        <AdditionalInfo>
          {t(
            `${SECTION_COST_INFO_PREFIX}.setupFeeAdditionalInfo`,
            'Wird auf Deiner ersten Rechnung belastet',
          )}
        </AdditionalInfo>
      </CostsItemInfoWrapper>
    </CostsInfoWrapper>
  );
};

export default CostsInfo;
